import { Checkbox } from "@material-ui/core";

export type { CheckboxProps } from "@material-ui/core";

export default Checkbox;
